import React from 'react';

const StaticApplicantFields: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
      {/* First row */}
      <div>
        <label className="block text-sm font-medium mb-1">
          FirstName<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">MiddleName</label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          LastName<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      {/* Second row */}
      <div>
        <label className="block text-sm font-medium mb-1">
          DateOfBirth<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          disabled
          placeholder="DD/MM/YYYY"
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          WhatsApp - Prefix Country Code<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          Email<span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      {/* Third row */}
      <div>
        <label className="block text-sm font-medium mb-1">City/Town</label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          Country<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          HighestEducation<span className="text-red-500">*</span>
        </label>
        <select disabled className="w-full p-2 border rounded bg-gray-100">
          <option>BachelorsDegree</option>
        </select>
      </div>
      {/* Fourth row */}
      <div className="md:col-span-1">
        <label className="block text-sm font-medium mb-1">
          Upload Resume<span className="text-red-500">*</span>
        </label>
        <input
          type="file"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium mb-1">
          Upload Intro Video<span className="text-red-500">*</span>
        </label>
        <input
          type="file"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium mb-1">Profile Photo</label>
        <input
          type="file"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>

      {/* Fifth row */}
      <div>
        <label className="block text-sm font-medium mb-1">FamilyMembers</label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">AnyDependents</label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      <div className="md:col-span-1">
        <label className="block text-sm font-medium mb-1">
          How soon can you begin work?
        </label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
      {/* Sixth row: Languages and Education */}
      <div className="md:col-span-2">
        <label className="block text-sm font-medium mb-1">
          LanguagesReadWrite<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          disabled
          className="w-full p-2 border rounded bg-gray-100"
        />
      </div>
    </div>
  );
};

export default StaticApplicantFields;
